
export class PhpHelper
{
    /**
     * Конвертируем Timestamp JS в PHP
     * @param jsTimestamp
     * @return {number}
     */
    static timestamp(jsTimestamp) {
        return Math.floor(jsTimestamp / 1000);
    }

    /**
     * PHP serialize
     * @param data
     * @return {*}
     */
    static serialize(data) {
        const _utf8Size = function (str) {
            let size = 0;
            let i = 0;
            let l = str.length;
            let code = "";
            for (i = 0; i < l; i++) {
                code = str[i].charCodeAt(0);
                if (code < 0x0080) {
                    size += 1;
                } else if (code < 0x0800) {
                    size += 2;
                } else {
                    size += 3;
                }
            }
            return size;
        };
        const _getType = function (inp) {
            let type = typeof inp;
            let match;
            let key;
            if (type === "object" && !inp) {
                return "null";
            }
            if (type === "object") {
                if (!inp.constructor) {
                    return "object";
                }
                let cons = inp.constructor.toString();
                match = cons.match(/(\w+)\(/);
                if (match) {
                    cons = match[1].toLowerCase();
                }
                const types = ["boolean", "number", "string", "array"];
                for (key in types) {
                    if (cons === types[key]) {
                        type = types[key];
                        break;
                    }
                }
            }
            return type;
        };
        const type = _getType(data);
        let val;
        let ktype = "";
        switch (type) {
            case "function":
                val = "";
                break;
            case "boolean":
                val = "b:" + (data ? "1" : "0");
                break;
            case "number":
                val = (Math.round(data) === data ? "i" : "d") + ":" + data;
                break;
            case "string":
                val = "s:" + _utf8Size(data) + ':"' + data + '"';
                break;
            case "array":
            case "object":
                val = "a";
                let count = 0;
                let vals = "";
                let okey;
                let key;
                for (key in data) {
                    if (data.hasOwnProperty(key)) {
                        ktype = _getType(data[key]);
                        if (ktype === "function") {
                            continue;
                        }
                        okey = key.match(/^[0-9]+$/) ? parseInt(key, 10) : key;
                        vals += this.serialize(okey) + this.serialize(data[key]);
                        count++;
                    }
                }
                val += ":" + count + ":{" + vals + "}";
                break;
            case "undefined":
            default:
                val = "N";
                break;
        }
        if (type !== "object" && type !== "array") {
            val += ";";
        }
        return val;
    }

    /**
     * PHP deserialize
     * @param data
     * @return {*}
     */
    static unserialize(data) {
        let self = this;
        const utf8Overhead = function (chr) {
            const code = chr.charCodeAt(0);
            if (code < 0x0080) {
                return 0;
            }
            if (code < 0x0800) {
                return 1;
            }
            return 2;
        };
        const error = function (type, msg, filename, line) {
            throw new self.window[type](msg, filename, line);
        };
        const read_until = function (data, offset, stopchr) {
            let buf = [];
            let chr = data.slice(offset, offset + 1);
            let i = 2;
            while (chr !== stopchr) {
                if (i + offset > data.length) {
                    error("Error", "Invalid");
                }
                buf.push(chr);
                chr = data.slice(offset + (i - 1), offset + i);
                i += 1;
            }
            return [buf.length, buf.join("")];
        };
        const read_chrs = function (data, offset, length) {
            let buf = [];
            for (let i = 0; i < length; i++) {
                let chr = data.slice(offset + (i - 1), offset + i);
                buf.push(chr);
                length -= utf8Overhead(chr);
            }
            return [buf.length, buf.join("")];
        };
        const _unserialize = function (data, offset) {
            let readdata;
            let readData;
            let chrs = 0;
            let ccount;
            let stringlength;
            let keyandchrs;
            let keys;
            if (!offset) {
                offset = 0;
            }
            const dtype = data.slice(offset, offset + 1).toLowerCase();
            let dataoffset = offset + 2;
            let typeconvert = function (x) {
                return x;
            };
            switch (dtype) {
                case "i":
                    typeconvert = function (x) {
                        return parseInt(x, 10);
                    };
                    readData = read_until(data, dataoffset, ";");
                    chrs = readData[0];
                    readdata = readData[1];
                    dataoffset += chrs + 1;
                    break;
                case "b":
                    typeconvert = function (x) {
                        return parseInt(x, 10) !== 0;
                    };
                    readData = read_until(data, dataoffset, ";");
                    chrs = readData[0];
                    readdata = readData[1];
                    dataoffset += chrs + 1;
                    break;
                case "d":
                    typeconvert = function (x) {
                        return parseFloat(x);
                    };
                    readData = read_until(data, dataoffset, ";");
                    chrs = readData[0];
                    readdata = readData[1];
                    dataoffset += chrs + 1;
                    break;
                case "n":
                    readdata = null;
                    break;
                case "s":
                    ccount = read_until(data, dataoffset, ":");
                    chrs = ccount[0];
                    stringlength = ccount[1];
                    dataoffset += chrs + 2;
                    readData = read_chrs(data, dataoffset + 1, parseInt(stringlength, 10));
                    chrs = readData[0];
                    readdata = readData[1];
                    dataoffset += chrs + 2;
                    if (chrs !== parseInt(stringlength, 10) && chrs !== readdata.length) {
                        error("SyntaxError", "String length mismatch");
                    }
                    readdata = self.utf8_decode(readdata);
                    break;
                case "a":
                    readdata = {};
                    keyandchrs = read_until(data, dataoffset, ":");
                    chrs = keyandchrs[0];
                    keys = keyandchrs[1];
                    dataoffset += chrs + 2;
                    for (let i = 0; i < parseInt(keys, 10); i++) {
                        const kprops = _unserialize(data, dataoffset);
                        const kchrs = kprops[1];
                        const key = kprops[2];
                        dataoffset += kchrs;
                        const vprops = _unserialize(data, dataoffset);
                        const vchrs = vprops[1];
                        const value = vprops[2];
                        dataoffset += vchrs;
                        readdata[key] = value;
                    }
                    dataoffset += 1;
                    break;
                default:
                    error("SyntaxError", "Unknown / Unhandled data type(s): " + dtype);
                    break;
            }
            return [dtype, dataoffset - offset, typeconvert(readdata)];
        };
        return _unserialize(data + "", 0)[2];
    }

    static utf8_decode(str_data) {
        let tmp_arr = [];
        let i = 0;
        let ac = 0;
        let c1 = 0;
        let c2 = 0;
        let c3 = 0;
        str_data += "";
        while (i < str_data.length) {
            c1 = str_data.charCodeAt(i);
            if (c1 < 128) {
                tmp_arr[ac++] = String.fromCharCode(c1);
                i++;
            } else if (c1 > 191 && c1 < 224) {
                c2 = str_data.charCodeAt(i + 1);
                tmp_arr[ac++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = str_data.charCodeAt(i + 1);
                c3 = str_data.charCodeAt(i + 2);
                tmp_arr[ac++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }
        return tmp_arr.join("");
    }
    static utf8_encode(argString) {
        let string = argString + "";
        let utftext = "";
        let start;
        let end;
        let stringl = 0;
        start = end = 0;
        stringl = string.length;
        for (let n = 0; n < stringl; n++) {
            const c1 = string.charCodeAt(n);
            let enc = null;
            if (c1 < 128) {
                end++;
            } else if (c1 > 127 && c1 < 2048) {
                enc = String.fromCharCode((c1 >> 6) | 192) + String.fromCharCode((c1 & 63) | 128);
            } else {
                enc = String.fromCharCode((c1 >> 12) | 224) + String.fromCharCode(((c1 >> 6) & 63) | 128) + String.fromCharCode((c1 & 63) | 128);
            }
            if (enc !== null) {
                if (end > start) {
                    utftext += string.substring(start, end);
                }
                utftext += enc;
                start = end = n + 1;
            }
        }
        if (end > start) {
            utftext += string.substring(start, string.length);
        }
        return utftext;
    }
}
